<!--
 * @Autor: suhang
 * @Date: 2022-05-17 15:42:30
 * @LastEditors: suhang
 * @LastEditTime: 2022-05-18 08:29:34
 * @Description: 
-->
<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
